import { useEffect, useState } from 'react';

const BYTE_MAX_VALUE = 255;
const PERCENT_MAX = 100;

export const useAudioLevel = (analyser: AnalyserNode | null): number => {
   const [level, setLevel] = useState(0);

   useEffect(() => {
      if (analyser === null) {
         setLevel(0);
         return undefined;
      }

      const data = new Uint8Array(analyser.frequencyBinCount);
      let animationFrame = 0;

      const measure = (): void => {
         analyser.getByteFrequencyData(data);
         const peak = data.reduce((max, value) => Math.max(max, value), 0);
         setLevel(Math.round((peak / BYTE_MAX_VALUE) * PERCENT_MAX));
         animationFrame = requestAnimationFrame(measure);
      };

      animationFrame = requestAnimationFrame(measure);

      return () => {
         cancelAnimationFrame(animationFrame);
         setLevel(0);
      };
   }, [analyser]);

   return level;
};
